import React from 'react';
import { Box } from '@fiverr-private/theme';
import type { StatusProps } from './types';
import { COLORS_BY_TYPE } from './constants';

const Status = ({ type = 'neutral', children }: StatusProps) => (
  <Box
    borderRadius="sm"
    minHeight="20px"
    display="flex"
    alignItems="center"
    paddingX="2"
    width="fit-content"
    letterSpacing="0.5px"
    fontSize="b_xxs"
    lineHeight="b_xs"
    fontWeight="bold"
    userSelect="none"
    {...COLORS_BY_TYPE[type]}
  >
    {children}
  </Box>
);

Status.displayName = 'Status';

export default Status;
